import { mapState } from 'vuex';

export default {
  data() {
    return {
      stickyFilterKey: '',
      collapsedFilterKeys: [],
      collapsedFilterKeysWithValues: [],
    };
  },

  computed: {
    ...mapState('user', ['currentAccount']),
  },

  methods: {
    async setStickyFilters(filters, filterOptions) {
      await this.$localForage.setItem(this.currentAccount.uuid + '-' + this.stickyFilterKey, filters);
      await this.$localForage.setItem(this.currentAccount.uuid + '-' + this.stickyFilterKey + 'Options', filterOptions);
    },

    async getStickyFilters() {
      let stickyFilters = await this.$localForage.getItem(this.currentAccount.uuid + '-' + this.stickyFilterKey);
      this.openMoreFiltersCheck(stickyFilters);
      return stickyFilters;
    },

    async getStickyFilterOptions() {
      return await this.$localForage.getItem(this.currentAccount.uuid + '-' + this.stickyFilterKey + 'Options');
    },

    openMoreFiltersCheck(stickyFilters) {
      let filters = Object.assign({}, stickyFilters);
      // First remove per_page, include, and sort.
      delete filters['per_page'];
      delete filters['include'];
      delete filters['sort'];

      // Next remove any `filter[COLLAPSED_KEYS]`.
      // The collapsed keys must be defined on each filter component that uses sticky filters and should be
      // an array of strings of the filters that are always shown.
      this.collapsedFilterKeys.forEach((key) => delete filters[`filter[${key}]`]);

      // remove any collapsed filters with specific values
      // this will be the case where we apply default filters e.g in_progress: true for the cases filter
      this.collapsedFilterKeysWithValues.forEach(([key, value]) => {
        const filterKey = `filter[${key}]`;
        if (filterKey in filters && filters[filterKey] === value) {
          delete filters[filterKey];
        }
      });
      filters = this.$nuxt.$helpers.removeNullPropertiesInObject(filters);

      // If the remaining object is greater than length 0 then one of the more filters
      // has been applied and so therefore openMoreFilters on the plannr filter component.
      if (Object.keys(filters).length > 0) {
        if (Object.keys(filters) !== 'filter[include_subfolders]') {
          this.$refs.PlannrFilters?.openMoreFilters();
        }
      }
    },

    //clear all filters
    async clearStickyFilters() {
      await this.$localForage.clear();
    },
  },
};
